import * as React from 'react';

import { Label } from './components/ui/label.js';

export function DimeLabel({ ...props }: Readonly<React.ComponentProps<typeof Label>>) {
  return <Label {...props} />;
}
